import React, { useEffect, useState } from "react";
import { useAuthentication } from "../../context/authentication";
import { useHistory, Link } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  Badge,
  Container,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { SecondaryListItems } from "../../components/drawer";
import { Group, User } from "../../database";
import firebase from "firebase";
import "./index.css";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import {
  fetchBooksByUser,
  fetchCummulativeData,
  fetchTransactions,
} from "../../database/Book";

const drawerWidth = 240;
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  addToUser: {
    marginBottom: 20,
  },
  userInfoContainer: {
    paddingLeft: 30,
  },
  table: {
    paddingLeft: 30,
    marginTop: 20,
  },
}));
const UsersScreen = () => {
  const { push } = useHistory();
  const { doLogout, user } = useAuthentication();
  const [transactions, setTransactions] = useState([]);
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logout = async () => {
    await doLogout();
    push("/login");
  };
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchTransactions(user.email);
      if (response && response.data) {
        setTransactions(response.data);
      }
    };
    if (user) {
      fetchData();
    }
  }, [user]);
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            Account
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          <ListItem>
            <Link to="/" style={{ color: "#000" }}>
              <ListItemIcon>
                <ListItemIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </Link>
          </ListItem>
          <SecondaryListItems logout={logout} />
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <div className={classes.userInfoContainer}>
            <Typography
              variant="h6"
              component="div"
              gutterBottom
              style={{ marginTop: "30px" }}
            >
              Earning Report (Excl. this month)
            </Typography>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>

                    <TableCell>Lifetime Earnings-paperback (In INR)</TableCell>
                    <TableCell>Lifetime Earnings-kindle (In INR)</TableCell>
                    <TableCell>Total Earning (In INR)</TableCell>
                    <TableCell>Payable</TableCell>
                    <TableCell>Transaction as of dated</TableCell>
                    <TableCell>Transaction By</TableCell>
                    <TableCell>Paid</TableCell>
                    <TableCell>Earning Status</TableCell>
                    <TableCell>Remarks (If any)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions.map((row) => (
                    <TableRow key={row.name}>
                      <TableCell component="th" scope="row">
                        {row.title}
                      </TableCell>
                      <TableCell>{row.lifeTimeEarningPaperBack}</TableCell>
                      <TableCell>{row.lifeTimeEarningAmazonKindle}</TableCell>
                      <TableCell>{row.totalEarning}</TableCell>
                      <TableCell>{row.payable}</TableCell>
                      <TableCell>{row.transactionDate}</TableCell>
                      <TableCell>{row.transactionBy || ""}</TableCell>
                      <TableCell>{row.deposit || ""}</TableCell>
                      <TableCell>{row.balance.toFixed(2) || ""}</TableCell>
                      <TableCell>{row.remarks || ""}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Container>
      </main>
    </div>
  );
};

export default UsersScreen;
